import { basicToaster } from '@ui/components/Toast';
import { Icon, IconProps } from '@ui/lib/park/ui/icon';
import { Text, TextProps } from '@ui/lib/park/ui/text';
import { shortenAddress } from '@ui/utils/formatAddress';
import { useCopyToClipboard } from 'react-use';

import { Copy } from './icons';

export type AddressProps = {
  address: string;
  leadingChars?: number;
  tailingChars?: number;
  isExpanded?: boolean;
  canCopy?: boolean;
  onClickCopy?: () => void;
  iconProps?: IconProps;
} & TextProps;

export const WalletAddress: React.FC<AddressProps> = ({
  address,
  isExpanded,
  canCopy,
  iconProps,
  leadingChars = 4,
  tailingChars = 4,
  onClickCopy = () => {},
  ...rest
}) => {
  const [, copy] = useCopyToClipboard();

  return (
    <Text textStyle="text.xsmall" {...rest}>
      {isExpanded
        ? address
        : shortenAddress({ address, leadingChars, tailingChars })}
      {canCopy ? (
        <Icon
          onClick={() => {
            copy(address);
            onClickCopy();
            basicToaster.success({
              title: 'Copied to clipboard',
            });
          }}
          cursor="pointer"
          boxSize="16px"
          verticalAlign="text-bottom"
          ml="4px"
          color="campaignCard.fg"
          {...iconProps}
        >
          <Copy />
        </Icon>
      ) : (
        <></>
      )}
    </Text>
  );
};
